import { render, staticRenderFns } from "./EmbedSignaturesPane.vue?vue&type=template&id=07f1218d&"
import script from "./EmbedSignaturesPane.vue?vue&type=script&lang=js&"
export * from "./EmbedSignaturesPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports